// extracted by mini-css-extract-plugin
export var statItem = "_iq-1";
export var statsRow = "_iq-0";